<template>
  <div class="header-section-component">
    <div class="columns">
      <div class="column is-12">
        <p class="is-size-1 is-size-3-mobile has-text-centered has-text-white dm-sans">
          <span v-if="isCreditCard">
            AGORA É SÓ PAGAR SEU BOLETO DA IMPLANTAÇÃO
          </span>
          <span v-else>
            AGORA É SÓ PAGAR SEU BOLETO
          </span>
        </p>
      </div>
    </div>
    <div class="columns" v-if="isCreditCard">
      <div class="column is-12">
        <p class="is-size-4 is-size-5-mobile has-text-centered has-text-white dm-sans">
          Esse boleto é separado da mensalidade e é necessário para realização do treinamento
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <p class="is-size-4 is-size-5-mobile has-text-centered has-text-white dm-sans">
          Pode fazer o download ou acessa-lo através do seu email
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'header-section',

  props: {
    isCreditCard: {
      type: Boolean,
      default: () => false
    }
  }

}

</script>

<style lang="scss" scoped>
.header-section-component {
  margin-bottom: 1.5rem;
  
  p {
    margin-bottom: 1rem;
    line-height: 1.3;
  }
}

@media screen and (max-width: 768px) {
  .header-section-component {
    margin-bottom: 1rem;
    
    .is-size-3-mobile {
      font-size: 1.5rem !important;
      line-height: 1.2;
    }
    
    .is-size-5-mobile {
      font-size: 1rem !important;
    }
    
    p {
      margin-bottom: 0.75rem;
      padding: 0 0.5rem;
    }
  }
}
</style>